import { render } from "./AssetView.vue?vue&type=template&id=565e662e"
import script from "./AssetView.vue?vue&type=script&lang=js"
export * from "./AssetView.vue?vue&type=script&lang=js"

import "./AssetView.vue?vue&type=style&index=0&id=565e662e&lang=css"

import exportComponent from "D:\\Github\\cj-assets\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__